<template>
  <div>
    <div class="col-sm">
      <div class="card">
        <div class="card-body text-center">
          <a href="#/integrations" @click.prevent="startIntegration">
            <img v-bind:src="logo" width="80" class="img-responsive">
          </a>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="step1Modal"
      aria-hidden="true"
      id="amazon-modal"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Integrate {{ marketplace }} Store</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="seller_id">Store Name</label>
                  <input
                    type="text"
                    name="seller_id"
                    id="seller_id"
                    class="form-control"
                    aria-label="Store URL"
                    aria-describedby="basic-addon1"
                    v-model="store_name"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="seller_id">Amazon Seller ID</label>
                  <input
                    type="text"
                    name="seller_id"
                    id="seller_id"
                    class="form-control"
                    aria-label="Store URL"
                    aria-describedby="basic-addon1"
                    v-model="seller_id"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="seller_id">Marketplace ID</label>
                  <input
                    type="text"
                    name="seller_id"
                    id="seller_id"
                    class="form-control"
                    aria-label="Store URL"
                    aria-describedby="basic-addon1"
                    v-model="mkt_id"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="seller_id">AWS Access Key</label>
                  <input
                    type="text"
                    name="seller_id"
                    id="seller_id"
                    class="form-control"
                    aria-label="Store URL"
                    aria-describedby="basic-addon1"
                    v-model="access_key"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="seller_id">Secret Key</label>
                  <input
                    type="text"
                    name="seller_id"
                    id="seller_id"
                    class="form-control"
                    aria-label="Store URL"
                    aria-describedby="basic-addon1"
                    v-model="secret_key"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for="auth_token">MWS Auth Token</label>
                  <input
                    type="text"
                    name="auth_token"
                    id="auth_token"
                    class="form-control"
                    aria-label="Store URL"
                    aria-describedby="basic-addon1"
                    v-model="auth_token"
                  >
                </div>
              </div>
              <div class="col-sm-4">
                <label>.</label>
                <!-- <button type="button" class="btn btn-info btn-block">Verify</button> -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="submitStep1">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    logo: null,
    code: null,
    marketplace: null
  },

  data() {
    return {
      seller_id: null,
      auth_token: null,
      mkt_id: null,
      access_key: null,
      secret_key: null,
      store_name: null
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },

  methods: {
    startIntegration(event) {
      if (this.user.subscribed) {
        $("#amazon-modal").modal();
      } else {
        this.$router.push("/my-account/subscription");
      }
    },
    submitStep1() {
      console.log(this.code);

      axios
        .post("/integrate/amazon", {
          seller_id: this.seller_id,
          auth_token: this.auth_token,
          mkt_id: this.mkt_id,
          access_key: this.access_key,
          secret_key: this.secret_key,
          store_name: this.store_name
        })
        .then(function(response) {
          // window.location = response.data.url;
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/NewIntegrationAmazon.vue